module.exports = __webpack_public_path__ + "static/img/11.44d816e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/11.jpg
// module id = IVk8
// module chunks = 1